import {CONSTANTS} from '@/constants'
import { functions } from '@/functions';
import miniToastr from "mini-toastr";

export const functions_voucher = {
    data: function () {
        return {
            voucher_statuses:[],
            payment_types:[],
            reportInvoiceResult:null,
            reportInvoiceText:null,
            reportInvoiceUrl:null,
            reportContractResult:null,
            reportContractText:null,
            reportContractUrl:null,
            exchangeVoucherContractResult:null,
            exchangeVoucherContractText:null,
            exchangeVoucherContractUrl:null,
            bannerContractResult:null,
            bannerContractText:null,
            bannerContractUrl:null,
        };
    },
    mixins: [functions],
    methods: {

        /**
         * Загрузка списка типов оплат
         */
        getPaymentTypes: function () {
            if (!this.payment_types.length) {
                this.payment_types = [];
                this.httpPrepare();
                this.$http.get(this.apiurl('voucher/payment-types')).then(function (response) {
                    response = this.httpSuccess(response);
                    this.payment_types = response.payload;
                }, this.httpError)
            }
        },
        /**
         * Загрузка списка статусов путевок
         */
        getStatuses: function () {
            if (!this.voucher_statuses.length) {
                this.voucher_statuses = [];
                this.httpPrepare();
                this.$http.get(this.apiurl('voucher/statuses')).then(function (response) {
                    response = this.httpSuccess(response);
                    this.voucher_statuses = response.payload;
                }, this.httpError)
            }
        },


        canEditClient:function (voucher) {
            if (!this.is(voucher)) voucher = this.voucher;
            switch (voucher.status_index) {
                case CONSTANTS.VOUCHER_STATE_DRAFT:
                case CONSTANTS.VOUCHER_STATE_DENIED:
                case CONSTANTS.VOUCHER_STATE_BOOKED:
                case CONSTANTS.VOUCHER_STATE_EXECUTING:
                case CONSTANTS.VOUCHER_STATE_REQUESTED:
                case CONSTANTS.VOUCHER_STATE_PRESENCE:
                case CONSTANTS.VOUCHER_STATE_ABSENCE:
                    return this.is_agent_or_agency || this.is_admin;
                default:
                    return false;
            }
        },

        canCalcPrices:function (voucher) {
            if (!this.is(voucher)) voucher = this.voucher;
            switch (voucher.status_index) {
                case CONSTANTS.VOUCHER_STATE_DRAFT:
                    return this.is_agent_or_agency || this.is_admin;
                default:
                    return false;
            }
        },
        canChangeUser:function (voucher) {
            if (!this.is(voucher)) voucher = this.voucher;
            return this.is_agent_or_agency || this.is_admin;
        },

        canDoRevoke: function (voucher) {
            if (!this.is(voucher)) voucher = this.voucher;
            switch (voucher.status_index) {
                case CONSTANTS.VOUCHER_STATE_CANCELLED:
                    return this.is_manager_or_buh || this.is_admin;
                default:
                    return false;
            }
        },

        canDoAnnul: function (voucher) {
            if (!this.is(voucher)) voucher = this.voucher;
            switch (voucher.status_index) {
                case CONSTANTS.VOUCHER_STATE_REFUSED:
                    return this.is_manager_or_buh || this.is_admin;
                default:
                    return false;
            }
        },

        canEditCompany:function (voucher) {
            if (!this.is(voucher)) voucher = this.voucher;
            switch (voucher.status_index) {
                case CONSTANTS.VOUCHER_STATE_ARCHIVED:
                case CONSTANTS.VOUCHER_STATE_REVOKED:
                    return false;
                default:
                    return this.is_agent_or_agency || this.is_admin;
            }
        },
        canEditGuests: function (voucher) {
            if (!this.is(voucher)) voucher = this.voucher;
            switch (voucher.status_index) {
                case CONSTANTS.VOUCHER_STATE_DRAFT:
                    return true;
                default:
                    return false;
            }
        },
        canEditInvoice: function(voucher) {
            if (!this.is(voucher)) voucher = this.voucher;

            switch (voucher.status_index) {
                case CONSTANTS.VOUCHER_STATE_BOOKED:
                case CONSTANTS.VOUCHER_STATE_EXECUTING:
                    return this.is_agent_or_agency || this.is_admin;
                default:
                    return false;
            }
        },
        canEditSettlement: function (voucher) {
            if (!this.is(voucher)) voucher = this.voucher;
            switch (voucher.status_index) {
                case CONSTANTS.VOUCHER_STATE_DRAFT:
                    return this.is_agent_or_agency || this.is_admin;
                default:
                    return false;
            }
        },
        canGetInvoice: function(voucher) {
            if (!this.is_agent_or_agency && !this.is_admin) return false;
            if (!this.is(voucher)) voucher = this.voucher;
            switch (voucher.status_index) {
                case CONSTANTS.VOUCHER_STATE_BOOKED:
                    return !this.is(voucher.ag_invoice_number);
                default:
                    return false;
            }
        },

        canRecycleVoucher: function (voucher) {
            if (!this.is(voucher)) voucher = this.voucher;
            switch (voucher.status_index) {
                case CONSTANTS.VOUCHER_STATE_AGREED:
                case CONSTANTS.VOUCHER_STATE_BOOKED:
                case CONSTANTS.VOUCHER_STATE_EXECUTING:
                    return this.is_agent_or_agency || this.is_admin;
                default:
                    return false;
            }
        },
        canResetPrices:function (voucher) {
            if (!this.is(voucher)) voucher = this.voucher;
            switch (voucher.status_index) {
                case CONSTANTS.VOUCHER_STATE_DRAFT:
                    return this.is_agent_or_agency || this.is_admin;
                default:
                    return false;
            }
        },
        canSave:function (voucher) {
            if (!this.is(voucher)) voucher = this.voucher;
            if (voucher.transfer_by_nsb)
                return this.is_manager_or_buh || this.is_agent_or_agency || this.is_admin;
            else
                return this.is_agent_or_agency || this.is_admin;

            // switch (voucher.status_index) {
            //     case CONSTANTS.VOUCHER_STATE_DRAFT:
            //         return this.is_agent_or_agency || this.is_admin;
            //     default:
            //         return false;
            // }
            //return true;
        },
        canSendToExecute:function (voucher) {
            if (!this.is(voucher)) voucher = this.voucher;
            return voucher.status_index === CONSTANTS.VOUCHER_STATE_BOOKED;
        },


        canDoRevert:function (voucher) {
            if (!this.is(voucher)) voucher = this.voucher;
            switch (voucher.status_index) {
                case CONSTANTS.VOUCHER_STATE_DENIED:
                case CONSTANTS.VOUCHER_STATE_PRESENCE:
                case CONSTANTS.VOUCHER_STATE_ABSENCE:
                    return this.is_agent_or_agency || this.is_admin;
                case CONSTANTS.VOUCHER_STATE_DRAFT:
                    return false;
                default:
                    return false;
            }
        },
        canDoClone:function (voucher) {
            switch (voucher.status_index) {
                case CONSTANTS.VOUCHER_STATE_REVOKED:
                case CONSTANTS.VOUCHER_STATE_CANCELLED:
                    return this.is_agent_or_agency || this.is_admin;
                default:
                    return false;
            }
        },
        canDoResponse: function (voucher) {
            if (!this.is(voucher)) voucher = this.voucher;
            switch (voucher.status_index) {
                case CONSTANTS.VOUCHER_STATE_REQUESTED:
                    return this.is_manager_or_buh || this.is_admin;
                default:
                    return false;
            }
        },
        canShowContacts: function(voucher) {
            if (!this.is(voucher)) voucher = this.voucher;
            if (voucher.transfer_by_nsb)
                return this.is_manager_or_buh || this.is_agent_or_agency || this.is_admin;
            else
                return this.is_agent_or_agency || this.is_admin;
        },
        canChangeTransferCompany: function(voucher) {
            if (!this.is(voucher)) voucher = this.voucher;
            switch (voucher.status_index) {
                case CONSTANTS.VOUCHER_STATE_DRAFT:
                case CONSTANTS.VOUCHER_STATE_AGREED:
                case CONSTANTS.VOUCHER_STATE_BOOKED:
                case CONSTANTS.VOUCHER_STATE_DENIED:
                case CONSTANTS.VOUCHER_STATE_EXECUTING:
                case CONSTANTS.VOUCHER_STATE_REQUESTED:
                case CONSTANTS.VOUCHER_STATE_PRESENCE:
                case CONSTANTS.VOUCHER_STATE_ABSENCE:
                    return this.is_agent_or_agency || this.is_admin;
                default:
                    return false;
            }
        },
        canChangeDirectPayment: function(voucher, hotel) {
            if (!this.is(voucher)) voucher = this.voucher;
            if (!this.is(hotel)) hotel = this.voucher.hotel;
            if (!this.is(hotel)) hotel = this.hotel;
            if (!this.is(hotel)) return false;
            if (!hotel.direct_payment) return false;

            switch (voucher.status_index) {
                case CONSTANTS.VOUCHER_STATE_DRAFT:
                case CONSTANTS.VOUCHER_STATE_AGREED:
                case CONSTANTS.VOUCHER_STATE_REQUESTED:
                case CONSTANTS.VOUCHER_STATE_PRESENCE:
                case CONSTANTS.VOUCHER_STATE_ABSENCE:
                    return this.is_agent_or_agency || this.is_admin;
                default:
                    return false;
                }
        },

        showInvoiceBlock: function(voucher) {
            if (!this.is(voucher)) voucher = this.voucher;
            switch (voucher.status_index) {
                case CONSTANTS.VOUCHER_STATE_BOOKED:
                case CONSTANTS.VOUCHER_STATE_EXECUTING:
                case CONSTANTS.VOUCHER_STATE_ARCHIVED:
                    return true;
                default:
                    return false;
            }
        },
        getTarifTitle: function (tarifs, tarif_id) {
            for(let i=0; i<tarifs.length; i++) {
                if (tarifs[i].id===tarif_id) { return tarifs[i].title; }
            }
            return '';
        },


        getVoucherStatusName: function(voucher_id) {
            return CONSTANTS.VOUCHER_STATE_NAMES[voucher_id];
        },

        /*
         * Проверка корректности сумм путевки
         */
        checkVoucherSums(voucher) {
            if ((voucher.summa_full - voucher.summa_discount) !== voucher.summa_payment) return 1;
            return 0;
        },

        bookingsSumBill(voucher) {
            if (!this.is(voucher)) voucher = this.voucher;
            if (!this.is(voucher.bookings)) return 0;

            let x = 0;

            for (let i=0; i<voucher.bookings.length; i++)
            {
                //console.log('voucher.bookings[i]', voucher.bookings[i].status, voucher.bookings[i].prebook, voucher.bookings[i].direct_payment)
                if ((voucher.bookings[i].status === CONSTANTS.BOOKING_STATUS_BOOKED) &&
                    !voucher.bookings[i].prebook &&
                    !voucher.bookings[i].direct_payment )
                {
                    //console.log('voucher.bookings[i].bill_value', voucher.bookings[i].bill_value)
                    x += voucher.bookings[i].bill_value;
                }
            }

            return x;
        },

        bookingsSumInvoice(voucher) {
            if (!this.is(voucher)) voucher = this.voucher;
            if (!this.is(voucher.bookings)) return 0;

            let x = 0;

            for (let i=0; i<voucher.bookings.length; i++)
            {
                //console.log('voucher.bookings[i]', voucher.bookings[i].status, voucher.bookings[i].prebook, voucher.bookings[i].direct_payment)
                if ((voucher.bookings[i].status === CONSTANTS.BOOKING_STATUS_PAYED) &&
                    !voucher.bookings[i].prebook &&
                    !voucher.bookings[i].direct_payment )
                {
                    //console.log('voucher.bookings[i].to_pay_value', voucher.bookings[i].to_pay_value)
                    x += voucher.bookings[i].to_pay_value;
                }
            }

            return x;
        },

        statusExpired: function (voucher) {
            let d = new Date();
            let csd = new Date(voucher.close_status_at);
            return csd < d;
        },

        canAccessVoucher: function (voucher) {
            if (!this.is(voucher)) return false;
            if (this.is_manager_or_buh || this.is_agency || this.is_admin) return true;
            return voucher.user_id === this.my_id;
        },

        latestVoucherClass: function (voucher) {
            return this.isLatest('App\\Models\\Voucher', voucher.id) ? 'latest' : '';
        },
        setLatestVoucher: function (id) {
            this.setLatest('App\\Models\\Voucher', id);
        },

        takeOrderNew: function (onSuccess=null, param=null) {
            this.httpPrepare();
            this.$http.post(this.apiurl('voucher/take')).then(function (response) {
                response = this.httpSuccess(response, true);
                if (!response) return;
                let voucher = response.payload.order;
                let count_taken = response.payload.count_taken;
                let extra_text = '';
                if (count_taken > 1) {
                    extra_text += ' Кроме того принято еще ' + (count_taken-1) + ' заявок с такими же контактными данными';
                }
                miniToastr["success"]('', 'Заявка '+voucher.id+' принята в работу' +extra_text, CONSTANTS.TOAST_SUCCESS_LIFETIME);
                this.setLatestVoucher(this.voucher.id);
                this.executeFunction(onSuccess, param, response.payload);
            }, this.httpError);
        },

    },
    computed: {

        show_company: {
            get () {
                return !!(this.voucher.blocks_show & CONSTANTS.BLOCK_COMPANY);
            },
            set (val) {
                this.voucher.blocks_show = (this.voucher.blocks_show & (~CONSTANTS.BLOCK_COMPANY)) | (val ?  CONSTANTS.BLOCK_COMPANY : 0);
            }
        },
        show_places: {
            get () {
                return !!(this.voucher.blocks_show & CONSTANTS.BLOCK_PLACES);
            },
            set (val) {
                this.voucher.blocks_show = (this.voucher.blocks_show & (~CONSTANTS.BLOCK_PLACES)) | (val ?  CONSTANTS.BLOCK_PLACES : 0);
            }
        },
        show_contacts: {
            get () {
                return !!(this.voucher.blocks_show & CONSTANTS.BLOCK_SOURCE);
            },
            set (val) {
                this.voucher.blocks_show = (this.voucher.blocks_show & (~CONSTANTS.BLOCK_SOURCE)) | (val ?  CONSTANTS.BLOCK_SOURCE : 0);
            }
        },
        show_source: {
            get () {
                return !!(this.voucher.blocks_show & CONSTANTS.BLOCK_CONTACTS);
            },
            set (val) {
                this.voucher.blocks_show = (this.voucher.blocks_show & (~CONSTANTS.BLOCK_CONTACTS)) | (val ?  CONSTANTS.BLOCK_CONTACTS : 0);
            }
        },
        show_requisites: {
            get () {
                return !!(this.voucher.blocks_show & CONSTANTS.BLOCK_REQUISITES);
            },
            set (val) {
                this.voucher.blocks_show = (this.voucher.blocks_show & (~CONSTANTS.BLOCK_REQUISITES)) | (val ?  CONSTANTS.BLOCK_REQUISITES : 0);
            }
        },
        show_orgreq: {
            get () {
                return !!(this.voucher.blocks_show & CONSTANTS.BLOCK_ORGREQ);
            },
            set (val) {
                this.voucher.blocks_show = (this.voucher.blocks_show & (~CONSTANTS.BLOCK_ORGREQ)) | (val ?  CONSTANTS.BLOCK_ORGREQ : 0);
            }
        },
        show_tourists: {
            get () {
                return !!(this.voucher.blocks_show & CONSTANTS.BLOCK_TOURISTS);
            },
            set (val) {
                this.voucher.blocks_show = (this.voucher.blocks_show & (~CONSTANTS.BLOCK_TOURISTS)) | (val ?  CONSTANTS.BLOCK_TOURISTS : 0);
            }
        },
        show_sums: {
            get () {
                return !!(this.voucher.blocks_show & CONSTANTS.BLOCK_SUMS);
            },
            set (val) {
                this.voucher.blocks_show = (this.voucher.blocks_show & (~CONSTANTS.BLOCK_SUMS)) | (val ?  CONSTANTS.BLOCK_SUMS : 0);
            }
        },
        show_info: {
            get () {
                return !!(this.voucher.blocks_show & CONSTANTS.BLOCK_INFO);
            },
            set (val) {
                this.voucher.blocks_show = (this.voucher.blocks_show & (~CONSTANTS.BLOCK_INFO)) | (val ?  CONSTANTS.BLOCK_INFO : 0);
            }
        },
        show_booking: {
            get () {
                return !!(this.voucher.blocks_show & CONSTANTS.BLOCK_BOOKING);
            },
            set (val) {
                this.voucher.blocks_show = (this.voucher.blocks_show & (~CONSTANTS.BLOCK_BOOKING)) | (val ?  CONSTANTS.BLOCK_BOOKING : 0);
            }
        },
        show_client_files: {
            get () {
                return !!(this.voucher.blocks_show & CONSTANTS.BLOCK_CLIENT_FILES);
            },
            set (val) {
                this.voucher.blocks_show = (this.voucher.blocks_show & (~CONSTANTS.BLOCK_CLIENT_FILES)) | (val ?  CONSTANTS.BLOCK_CLIENT_FILES : 0);
            }
        },
        show_comment: {
            get () {
                return !!(this.voucher.blocks_show & CONSTANTS.BLOCK_COMMENT);
            },
            set (val) {
                this.voucher.blocks_show = (this.voucher.blocks_show & (~CONSTANTS.BLOCK_COMMENT)) | (val ?  CONSTANTS.BLOCK_COMMENT : 0);
            }
        },
        show_invoice: {
            get () {
                return !!(this.voucher.blocks_show & CONSTANTS.BLOCK_INVOICE);
            },
            set (val) {
                this.voucher.blocks_show = (this.voucher.blocks_show & (~CONSTANTS.BLOCK_INVOICE)) | (val ?  CONSTANTS.BLOCK_INVOICE : 0);
            }
        },
        show_telecalls: {
            get () {
                return !!(this.voucher.blocks_show & CONSTANTS.BLOCK_TELECALLS);
            },
            set (val) {
                this.voucher.blocks_show = (this.voucher.blocks_show & (~CONSTANTS.BLOCK_TELECALLS)) | (val ?  CONSTANTS.BLOCK_TELECALLS : 0);
            }
        },
        show_checkin_data: {
            get () {
                return !!(this.voucher.blocks_show & CONSTANTS.BLOCK_CHECKIN_DATA);
            },
            set (val) {
                this.voucher.blocks_show = (this.voucher.blocks_show & (~CONSTANTS.BLOCK_CHECKIN_DATA)) | (val ?  CONSTANTS.BLOCK_CHECKIN_DATA : 0);
            }
        },
        show_discounts: {
            get () {
                return !!(this.voucher.blocks_show & CONSTANTS.BLOCK_DISCOUNTS);
            },
            set (val) {
                this.voucher.blocks_show = (this.voucher.blocks_show & (~CONSTANTS.BLOCK_DISCOUNTS)) | (val ?  CONSTANTS.BLOCK_DISCOUNTS : 0);
            }
        },
        show_client_payments: {
            get () {
                return !!(this.voucher.blocks_show & CONSTANTS.BLOCK_CLPAYMENTS);
            },
            set (val) {
                this.voucher.blocks_show = (this.voucher.blocks_show & (~CONSTANTS.BLOCK_CLPAYMENTS)) | (val ?  CONSTANTS.BLOCK_CLPAYMENTS : 0);
            }
        },
        show_tickets: {
            get () {
                return !!(this.voucher.blocks_show & CONSTANTS.BLOCK_TICKETS);
            },
            set (val) {
                this.voucher.blocks_show = (this.voucher.blocks_show & (~CONSTANTS.BLOCK_TICKETS)) | (val ?  CONSTANTS.BLOCK_TICKETS : 0);
            }
        },

        status_expired: function() {
            return this.statusExpired(this.voucher);
        },
    }
};
